import { Component, OnInit } from '@angular/core';
import { FormGroup, AbstractControl, FormControl, Validators, FormBuilder } from '@angular/forms';
import { Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { Environment } from 'src/app/stores/environment.store';
import { MatDialog, MatSnackBar } from '@angular/material';
import { DataService, searchFilterBy } from 'src/app/services/data.service';
import { debounceTime, tap, switchMap } from 'rxjs/operators';
import { ConvertService } from 'src/app/services/convert.service';
import { recordStatus } from 'src/app/dummy/status';
import { AutoCompleteStore } from 'src/app/stores/autocomplete.store';
import { ClassroomStore } from 'src/app/stores/enrollment/classroom.store';

@Component({
  selector: 'app-classroom-student',
  templateUrl: './classroom-student.component.html',
  styleUrls: ['./classroom-student.component.scss']
})
export class ClassroomStudentComponent implements OnInit {

  formFocus: boolean;
  form: FormGroup;
  search: AbstractControl;
  searchType: AbstractControl;
  filterBy = searchFilterBy;
  loading: boolean = false;
  admissionKey: string;
  enrollmentKey: string;
  block: boolean = false;
  creditRef: any;
  creditAmount: number;
  scholarshipPenalty: number;
  scholarshipPenaltyRef: any;
  statusRef: any;

  filteredStates: Observable<any[]>;
  shiftControl = new FormControl('', [Validators.required]);
  programControl = new FormControl(null, [Validators.required]);
  programs;
  process: boolean = false;

  isValidKey: boolean = false;
  isAdmin: boolean = false;
  autoStudent;
  id;
  constructor(
    private route: ActivatedRoute,
    public env: Environment,
    public dialog: MatDialog,
    private fb: FormBuilder,
    private snackBar: MatSnackBar,
    private router: Router,
    private ds: DataService,
    private autoStore: AutoCompleteStore,
    private store: ClassroomStore
  ) { }

  ngOnInit() {
    this.env.getUser(res => {
      this.isAdmin = false;

    })
    this.route.parent.params.subscribe(param => {
      this.id = param.id;
      if (this.id) {
        this.store.fetchClassroom(this.id)
        this.store.fetchStudentClassroom(this.id)
      }
    })
    this.buildForm();

    this.autoStore.fetchAutoDataStudentCallBack('students', data => {
      if (data) {
        this.autoStudent = data;
      }
    });

    this.search.valueChanges
      .pipe(
        debounceTime(300),
        tap(() => (false)),
        switchMap(value => this.autoStore.fetchSearchStudentCallback("students", this.searchType.value.key, value, data => {
          if (data) {
            this.autoStudent = data;
          }
        }))
      ).subscribe(res => { });
  }

  _onSelectedChange(event) {

  }

  _release() {

  }

  buildForm() {
    this.form = this.fb.group({
      searchType: [searchFilterBy[0], [Validators.required]],
      search: [null]
    });
    this.search = this.form.controls["search"];
    this.searchType = this.form.controls["searchType"];
  }

  displayItem(item: any): string {
    if (this.searchType) {
      const { key } = this.searchType.value;
      return item ? item[key] : item;
    }
    return item ? item.phoneNumber : item;
  }

  compareObjects(o1: any, o2: any): boolean {
    if (o2) {
      return o1.text === o2.text;
    }
  }

  _goBack() {
    this.router.navigate(['/enrollment']);
  }

  _onFocus(yes) {
    this.formFocus = yes;
  }

  _onSearch(item: any) {
    const filter = this.form.value.search;
    if (typeof filter == 'string') {
      // const { search, searchType } = item;
      const data = this.autoStudent.filter(f => f[item.searchType.key] == filter.toUpperCase())[0]
      if (data) {
        this._saveEnroll(data, this.id)
      }
    } else {
      this._saveEnroll(filter, this.id)
    }
  }

  _optionSelected(item) {

  }

  onRouter(item, admissionKey) {


  }
  _selectionChange(event) {
    const { value } = event;

  }

  _selectionCourse(event) {

  }

  _remove(item, id) {
    this.store.removeStudent(item, id, (success, res) => {
      this.snackBar.open("Student has been remove from class successful.", "Done", { duration: 1000 });
    })

  }

  _saveEnroll(data, id) {
    if (this.form.valid) {
      this.store.addStudent(data, id, (success, res) => {
        this.snackBar.open("Student has been add to class successful.", "Done", { duration: 1000 });
        this.form.controls['search'].reset();
        this.form.enable();
      })
    }
  }

  _onEnrollCourse() {

  }

  _onUpdateCourseSchedule() {

  }

  _onBatchEnrollCourse() {


  }

}
